export default {
  en: {
    messages: {
      required: 'Required',
      email: 'Please enter a valid email address.',
      validFullName: 'Please enter a valid first name and a last name.'
    },
    custom: {
      email: {
        required: 'Please enter an email address.'
      },
      fullName: {
        required: 'Please enter a valid full name.',
        validateFullName: 'Please ensure that you have entered a first and last name.'
      },
      firstName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? 'First Name is required' : 'Please enter your first name.'
        }
      },
      lastName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? 'Last Name is required' : 'Please enter your last name.'
        }
      },
      dob: {
        required: 'Please enter your date of birth.'
      },
      password: {
        required: 'Please enter a password.',
        min: 'Password must contain at least 8 characters.'
      },
      postalCode: {
        required: 'Please enter a valid postal code.',
        min: function (_, min) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `Please enter a valid postal code in ${min} digits (e.g. 0200)`
            case 'nz':
              return `Please enter a valid postal code in ${min} digits (e.g. 02000)`
            case 'th':
              return `Please enter a valid postal code in ${min} digits`
            case 'my':
              return `Please enter a valid postal code in ${min} digits (e.g. 02000)`
            case 'ph':
              return `Please enter a valid postal code in ${min} digits (e.g. 0550)`
            case 'id':
              return `Please enter a valid postal code in 5 digits`
            default:
              return `Please enter a valid postal code in ${min} digits`
          }
        },
        max: function (_, max) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `Please enter a valid postal code in ${max} digits (e.g. 0200)`
            case 'nz':
              return `Please enter a valid postal code in ${max} digits (e.g. 02000)`
            case 'th':
              return `Please enter a valid postal code in ${max} digits`
            case 'my':
              return `Please enter a valid postal code in ${max} digits (e.g. 02000)`
            case 'ph':
              return `Please enter a valid postal code in ${max} digits (e.g. 0550)`
            case 'id':
              return `Please enter a valid postal code in ${max} digits`
            default:
              return `Please enter a valid postal code in ${max} digits`
          }
        }
      },
      city: {
        required: 'Please select a valid city.'
      },
      state: {
        required: 'Please select a valid state.'
      },
      suburb: {
        required: 'Please select a valid suburb.'
      },
      addressOne: {
        required: 'Please enter a valid address.',
        max: (_, max) => `Please ensure that your address is below ${max} characters`
      },
      district: {
        required: 'Please select a valid district.'
      },
      province: {
        required: 'Please select a valid province.'
      },
      addressAndBarangay: {
        required: 'Please enter a valid address & barangay.'
      },
      contactNumber: {
        required: 'Please enter a valid contact number.',
        numeric: 'Please ensure that only numbers have been input.',
        validatePhoneNumber: 'Your phone number appears to be invalid.'
      },
      mobileNumber: {
        required: 'Please enter a valid mobile number.',
        numeric: 'Please ensure that only numbers have been input.',
        validatePhoneNumber: 'Your phone number appears to be invalid.'
      },
      membershipId: {
        required: 'Please enter your membership ID number.'
      },
      beautyPassNumber: {
        required: 'Please enter your Beauty Pass number to link your Sephora membership with Lazada'
      },
      distributionConsent: {
        required: 'Please accept the privacy policy to continue.'
      },
      nameOnCard: {
        required: 'Please enter the name.',
        nameOnCardValidator: 'Please enter a valid credit card name.'
      },
      cardNumber: {
        required: 'Please enter the card number.',
        cardNumberValidator: 'Please enter a valid credit card number.',
        cardAvailability: 'Card entered is not supported. Please try using another card.'
      },
      expiration: {
        required: 'Please enter the expiration date.',
        expirationValidator: 'Please enter a valid expiration date.'
      },
      cvc: {
        required: 'Please enter the cvc.',
        cvcValidator: 'Please enter a valid cvc.'
      },
      phoneNumberCode: {
        required: 'Please select the country code.',
        phoneNumberValidator: 'Please enter a valid country code or phone number.'
      },
      phoneNumber: {
        required: 'Please enter the phone number.',
        phoneNumberValidator: 'Please enter a valid country code or phone number.'
      },
      selfCollectionSelection: {
        required: 'Please select a self collection option to continue.'
      },
      issuers: {
        required: 'Please select a valid payment method.'
      },
      collectInfo: {
        required: 'Please check compulsory agreements.'
      },
      discloseInfo: {
        required: 'Please check compulsory agreements.'
      },
      name: {
        unicodesValidator: 'Emojis are not allowed'
      },
      title: {
        unicodesValidator: 'Emojis are not allowed'
      },
      text: {
        unicodesValidator: 'Emojis are not allowed'
      }
    }
  }
}
